export function getPlayerApiBaseUrl(): string {
	const baseUrl = import.meta.env.VITE_PLAYER_API_BASE_URL

	if (!baseUrl) {
		console.warn('VITE_PLAYER_API_BASE_URL is not configured')
		return ''
	}

	return baseUrl.replace(/\/$/, '')
}

export function resolvePlayerAssetUrl(path: string): string {
	if (!path) {
		return ''
	}

	if (/^https?:\/\//.test(path)) {
		return path
	}

	const origin = getPlayerApiBaseUrl()

	if (!origin) {
		return path
	}

	return `${origin}${path.startsWith('/') ? path : `/${path}`}`
}
